/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShipperCompany } from '../../models/shipper-company';
import { UpdateShipperDto } from '../../models/update-shipper-dto';

export interface UpdateOneBaseMgmtShipperControllerShipperCompany$Params {
  id: number;
      body: UpdateShipperDto
}

export function updateOneBaseMgmtShipperControllerShipperCompany(http: HttpClient, rootUrl: string, params: UpdateOneBaseMgmtShipperControllerShipperCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipperCompany>> {
  const rb = new RequestBuilder(rootUrl, updateOneBaseMgmtShipperControllerShipperCompany.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShipperCompany>;
    })
  );
}

updateOneBaseMgmtShipperControllerShipperCompany.PATH = '/api/mgmt/shippers/{id}';
